module.exports = __webpack_public_path__ + "img/DTI-02.a0a12910.png";